import React, { useState, useEffect } from 'react';
import { 
  FaWhatsapp, 
  FaTelegram, 
  FaLink, 
  FaUsers, 
  FaUserPlus, 
  FaCoins, 
  FaMoneyBillWave,
  FaChartLine,
  FaCopy,
  FaShare,
  FaCheck,
  FaTwitter,
  FaFacebook
} from 'react-icons/fa';
import BottomNavigation from './BottomNavigation';
import { useAuth } from '../security/security/AuthContext';
import axios from 'axios';

const Team = () => {
  const { userDetails, token, updateUserDetails } = useAuth();
  const [referralStats, setReferralStats] = useState({ totalReferrals: 0, totalRevenue: 0 });
  const [inviteLink, setInviteLink] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [expandedSection, setExpandedSection] = useState(null);
  const [referralHistory, setReferralHistory] = useState([]);

  // Styles
  const styles = {
    container: {
      backgroundColor: '#0F172A',
      color: '#E2E8F0',
      minHeight: '100vh',
      paddingBottom: '80px',
      fontFamily: 'Inter, system-ui, sans-serif',
    },
    header: {
      background: 'linear-gradient(135deg, #1A365D 0%, #0F172A 100%)',
      padding: '20px',
      borderBottom: '1px solid #2D3748',
      marginBottom: '16px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    title: {
      fontSize: '24px',
      fontWeight: '700',
      color: '#F8FAFC',
      margin: '0 0 4px 0',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    subtitle: {
      fontSize: '14px',
      color: '#94A3B8',
      margin: '0',
      textAlign: 'center',
      maxWidth: '300px',
    },
    card: {
      background: 'linear-gradient(145deg, #1E293B 0%, #0F172A 100%)',
      borderRadius: '16px',
      padding: '20px',
      margin: '16px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
      border: '1px solid #334155',
      overflow: 'hidden',
      position: 'relative',
    },
    statsCard: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '12px',
    },
    largeStatsCard: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '16px',
    },
    statItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '16px',
      backgroundColor: 'rgba(15, 23, 42, 0.5)',
      borderRadius: '12px',
      border: '1px solid #334155',
    },
    statValue: {
      fontSize: '24px',
      fontWeight: '700',
      color: '#38BDF8',
      marginBottom: '8px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    secondaryStatValue: {
      fontSize: '20px',
      fontWeight: '700',
      color: '#F8FAFC',
    },
    statLabel: {
      fontSize: '12px',
      color: '#94A3B8',
      textAlign: 'center',
    },
    inviteLinkCard: {
      padding: '0',
      overflow: 'hidden',
    },
    inviteLinkHeader: {
      padding: '16px 20px',
      borderBottom: '1px solid #334155',
      fontSize: '16px',
      fontWeight: '600',
      color: '#F8FAFC',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    inviteLinkContent: {
      padding: '16px 20px',
    },
    inviteLinkText: {
      fontSize: '14px',
      color: '#94A3B8',
      marginBottom: '12px',
    },
    inviteLink: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'rgba(15, 23, 42, 0.8)',
      border: '1px solid #334155',
      borderRadius: '8px',
      padding: '12px 16px',
      fontSize: '14px',
      color: '#F8FAFC',
      overflow: 'hidden',
      position: 'relative',
    },
    inviteLinkBox: {
      flex: 1,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    copyButton: {
      backgroundColor: 'transparent',
      border: 'none',
      color: '#38BDF8',
      cursor: 'pointer',
      padding: '4px 8px',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      fontSize: '14px',
    },
    shareButtonsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      marginTop: '20px',
    },
    shareLabel: {
      fontSize: '14px',
      color: '#94A3B8',
      margin: '0 0 4px 0',
    },
    shareButtons: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap',
    },
    shareButton: {
      flex: '1 0 calc(50% - 5px)',
      backgroundColor: '#1E293B',
      color: '#E2E8F0',
      border: '1px solid #334155',
      borderRadius: '8px',
      padding: '12px 16px',
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    whatsappButton: {
      backgroundColor: 'rgba(37, 211, 102, 0.2)',
      color: '#25D366',
      borderColor: 'rgba(37, 211, 102, 0.3)',
    },
    telegramButton: {
      backgroundColor: 'rgba(0, 136, 204, 0.2)',
      color: '#0088cc',
      borderColor: 'rgba(0, 136, 204, 0.3)',
    },
    twitterButton: {
      backgroundColor: 'rgba(29, 161, 242, 0.2)',
      color: '#1DA1F2',
      borderColor: 'rgba(29, 161, 242, 0.3)',
    },
    facebookButton: {
      backgroundColor: 'rgba(66, 103, 178, 0.2)',
      color: '#4267B2',
      borderColor: 'rgba(66, 103, 178, 0.3)',
    },
    sectionTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#F8FAFC',
      margin: '24px 16px 8px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    rewardsCard: {
      padding: '20px',
      background: 'linear-gradient(145deg, #1E3A5F 0%, #1E293B 100%)',
    },
    rewardsInner: {
      backgroundColor: 'rgba(15, 23, 42, 0.7)',
      borderRadius: '12px',
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    rewardsTiers: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    rewardsTier: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '12px',
      borderRadius: '8px',
      backgroundColor: 'rgba(15, 23, 42, 0.5)',
      border: '1px solid #334155',
    },
    tierLevel: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#F8FAFC',
    },
    tierReward: {
      fontSize: '14px',
      color: '#38BDF8',
      fontWeight: '500',
    },
    tierDescription: {
      fontSize: '12px',
      color: '#94A3B8',
      marginTop: '4px',
    },
    accordionHeader: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#F8FAFC',
      padding: '16px',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #334155',
    },
    accordionIcon: {
      transition: 'transform 0.2s ease',
    },
    accordionContent: {
      maxHeight: '0',
      overflow: 'hidden',
      transition: 'max-height 0.3s ease',
      backgroundColor: 'rgba(15, 23, 42, 0.5)',
    },
    expandedAccordion: {
      maxHeight: '500px',
      padding: '16px',
    },
    howItWorksSteps: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    step: {
      display: 'flex',
      gap: '12px',
    },
    stepNumber: {
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      backgroundColor: '#38BDF8',
      color: '#0F172A',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      fontWeight: '600',
      flexShrink: 0,
    },
    stepContent: {
      flex: 1,
    },
    stepTitle: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#F8FAFC',
      marginBottom: '4px',
    },
    stepDescription: {
      fontSize: '12px',
      color: '#94A3B8',
    },
    historyItem: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '12px',
      borderBottom: '1px solid #334155',
    },
    userInfo: {
      display: 'flex',
      flexDirection: 'column',
    },
    userName: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#F8FAFC',
    },
    joinDate: {
      fontSize: '12px',
      color: '#94A3B8',
    },
    commission: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#10B981',
    },
    toast: {
      position: 'fixed',
      bottom: '80px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#1E293B',
      color: 'white',
      padding: '12px 16px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      zIndex: 1001,
      width: '90%',
      maxWidth: '320px',
      border: '1px solid #38BDF8',
      opacity: showToast ? 1 : 0,
      visibility: showToast ? 'visible' : 'hidden',
      transition: 'opacity 0.2s ease, visibility 0.2s ease',
    },
    particles: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflow: 'hidden',
      pointerEvents: 'none',
      zIndex: 0,
    },
  };

  const refreshUserData = async () => {
    try {
      setLoading(true);
      const userResponse = await axios.get(`https://api.novasoftwaves.com/api/v1/auth/${userDetails.email}`, {
        headers: {
          'Authorization': token
        }
      });
      updateUserDetails(userResponse.data);
      setLoading(false);
    } catch (error) {
      console.error('Error refreshing user data:', error);
      setLoading(false);
    }
  };

  const fetchReferralHistory = async () => {
    try {
      const response = await axios.get(`https://api.novasoftwaves.com/api/v1/auth/referrals/${userDetails.email}`, {
        headers: {
          'Authorization': token
        }
      });
      
      if (response.data) {
        setReferralHistory(response.data);
      }
    } catch (error) {
      console.error('Error fetching referral history:', error);
    }
  };

  useEffect(() => {
    refreshUserData();
    fetchReferralHistory();
    
    setInviteLink(`https://novasoftwaves.com/signup?invite_code=${userDetails.invitationCode}`);
  }, [userDetails.invitationCode]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(inviteLink);
    setToastMessage('Invitation link copied to clipboard!');
    setShowToast(true);
    
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  const shareViaWhatsApp = () => {
    const message = `🚀 Join me on Nova Soft-waves and start earning crypto rewards! Use my invitation code to get started: ${userDetails.invitationCode}\n\n${inviteLink}`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/?text=${encodedMessage}`, '_blank');
  };

  const shareViaTelegram = () => {
    const message = `🚀 Join me on Nova Soft-waves and start earning crypto rewards! Use my invitation code to get started: ${userDetails.invitationCode}\n\n${inviteLink}`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://t.me/share/url?url=${inviteLink}&text=${encodedMessage}`, '_blank');
  };

  const shareViaTwitter = () => {
    const message = `🚀 Join me on Nova Soft-waves and start earning crypto rewards! Use my invitation code to get started: ${userDetails.invitationCode}`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://twitter.com/intent/tweet?text=${encodedMessage}&url=${encodeURIComponent(inviteLink)}`, '_blank');
  };

  const shareViaFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(inviteLink)}`, '_blank');
  };

  const toggleSection = (section) => {
    if (expandedSection === section) {
      setExpandedSection(null);
    } else {
      setExpandedSection(section);
    }
  };

  // Sample referral data for visualization
  const sampleReferrals = [
    { name: "John D.", date: "2023-10-15", commission: 150 },
    { name: "Alice S.", date: "2023-10-12", commission: 120 },
    { name: "Robert M.", date: "2023-10-08", commission: 200 },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>
          <FaUsers /> Referral Program
        </h1>
        <p style={styles.subtitle}>
          Invite friends to earn passive commission on their mining activity
        </p>
      </div>

      <div style={styles.card}>
        <div style={styles.largeStatsCard}>
          <div style={styles.statItem}>
            <div style={styles.statValue}>
              <FaUserPlus /> {userDetails.totalReferrals || 0}
            </div>
            <span style={styles.statLabel}>Total Referrals</span>
          </div>
          <div style={styles.statItem}>
            <div style={styles.statValue}>
              <FaCoins /> {userDetails.invitationIncome || 0}
            </div>
            <span style={styles.statLabel}>Total Commission (KES)</span>
          </div>
        </div>
      </div>

      <div style={{...styles.card, ...styles.inviteLinkCard}}>
        <div style={styles.inviteLinkHeader}>
          <span>Your Invitation Link</span>
        </div>
        <div style={styles.inviteLinkContent}>
          <p style={styles.inviteLinkText}>
            Share this link with friends to start earning commissions
          </p>
          <div style={styles.inviteLink}>
            <div style={styles.inviteLinkBox}>
              {inviteLink}
            </div>
            <button 
              style={styles.copyButton}
              onClick={copyToClipboard}
            >
              <FaCopy /> Copy
            </button>
          </div>

          <div style={styles.shareButtonsContainer}>
            <p style={styles.shareLabel}>Share via:</p>
            <div style={styles.shareButtons}>
              <button 
                style={{...styles.shareButton, ...styles.whatsappButton}}
                onClick={shareViaWhatsApp}
              >
                <FaWhatsapp /> WhatsApp
              </button>
              <button 
                style={{...styles.shareButton, ...styles.telegramButton}}
                onClick={shareViaTelegram}
              >
                <FaTelegram /> Telegram
              </button>
              <button 
                style={{...styles.shareButton, ...styles.twitterButton}}
                onClick={shareViaTwitter}
              >
                <FaTwitter /> Twitter
              </button>
              <button 
                style={{...styles.shareButton, ...styles.facebookButton}}
                onClick={shareViaFacebook}
              >
                <FaFacebook /> Facebook
              </button>
            </div>
          </div>
        </div>
      </div>

      <h2 style={styles.sectionTitle}>
        <FaMoneyBillWave /> Commission Structure
      </h2>
      <div style={{...styles.card, ...styles.rewardsCard}}>
        <div style={styles.rewardsInner}>
          <div style={styles.rewardsTiers}>
            <div style={styles.rewardsTier}>
              <div>
                <div style={styles.tierLevel}>Level 1</div>
                <div style={styles.tierDescription}>Direct Referrals</div>
              </div>
              <div style={styles.tierReward}>10% Commission</div>
            </div>
            <div style={styles.rewardsTier}>
              <div>
                <div style={styles.tierLevel}>Level 2</div>
                <div style={styles.tierDescription}>Friends of Friends</div>
              </div>
              <div style={styles.tierReward}>3% Commission</div>
            </div>
            <div style={styles.rewardsTier}>
              <div>
                <div style={styles.tierLevel}>Level 3</div>
                <div style={styles.tierDescription}>Extended Network</div>
              </div>
              <div style={styles.tierReward}>1% Commission</div>
            </div>
          </div>
        </div>
      </div>

      <div style={{...styles.card, marginTop: '24px'}}>
        <div 
          style={styles.accordionHeader}
          onClick={() => toggleSection('howItWorks')}
        >
          How It Works
          <span 
            style={{
              ...styles.accordionIcon, 
              transform: expandedSection === 'howItWorks' ? 'rotate(180deg)' : 'rotate(0)'
            }}
          >
            ▼
          </span>
        </div>
        <div 
          style={{
            ...styles.accordionContent,
            ...(expandedSection === 'howItWorks' ? styles.expandedAccordion : {})
          }}
        >
          <div style={styles.howItWorksSteps}>
            <div style={styles.step}>
              <div style={styles.stepNumber}>1</div>
              <div style={styles.stepContent}>
                <div style={styles.stepTitle}>Share Your Link</div>
                <div style={styles.stepDescription}>
                  Copy your unique referral link and share it with friends through social media, messaging apps, or email.
                </div>
              </div>
            </div>
            <div style={styles.step}>
              <div style={styles.stepNumber}>2</div>
              <div style={styles.stepContent}>
                <div style={styles.stepTitle}>Friends Sign Up</div>
                <div style={styles.stepDescription}>
                  When your friends click the link and create an account, they're automatically linked to you as their referrer.
                </div>
              </div>
            </div>
            <div style={styles.step}>
              <div style={styles.stepNumber}>3</div>
              <div style={styles.stepContent}>
                <div style={styles.stepTitle}>Earn Commissions</div>
                <div style={styles.stepDescription}>
                  You'll earn commissions on your referrals' mining activity. Commissions are automatically added to your wallet.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div 
          style={styles.accordionHeader}
          onClick={() => toggleSection('referralHistory')}
        >
          Your Referrals
          <span 
            style={{
              ...styles.accordionIcon, 
              transform: expandedSection === 'referralHistory' ? 'rotate(180deg)' : 'rotate(0)'
            }}
          >
            ▼
          </span>
        </div>
        <div 
          style={{
            ...styles.accordionContent,
            ...(expandedSection === 'referralHistory' ? styles.expandedAccordion : {})
          }}
        >
          {referralHistory && referralHistory.length > 0 ? (
            referralHistory.map((referral, index) => (
              <div key={index} style={styles.historyItem}>
                <div style={styles.userInfo}>
                  <span style={styles.userName}>{referral.name || referral.email}</span>
                  <span style={styles.joinDate}>Joined: {new Date(referral.joinDate).toLocaleDateString()}</span>
                </div>
                <span style={styles.commission}>+KES {referral.commission || 0}</span>
              </div>
            ))
          ) : (
            <p style={{color: '#94A3B8', textAlign: 'center', padding: '16px'}}>
              You haven't referred anyone yet. Share your link to start earning!
            </p>
          )}
        </div>
      </div>

      {showToast && (
        <div style={styles.toast}>
          <FaCheck color="#38BDF8" />
          <span>{toastMessage}</span>
        </div>
      )}

      <BottomNavigation />

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0px); }
        }
        
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default Team;